<nb-accordion multi class="custom-accordion mt-0">

  <nb-accordion-item expanded>
    <nb-accordion-item-header>
      <span class="text">
        {{ 'Estimates of refrigerant leaks' | translate }}
      </span>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <table class="table skeleton">
        <thead>
          <tr>
            <th class="w-20 align-middle">{{ "Building" | translate }}</th>
            <th class="align-middle">{{ "Refrigerant fluid type" | translate }}</th>
            <th class="align-middle">{{ "Estimated climate impact" | translate }} ({{ 'kg eq CO2 year' | translate }})
            </th>
            @if (!readOnly) {
              <!-- <th class="align-middle"></th>
              <th class="align-middle"></th> -->
            }
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="align-middle"></td>
            <td class="align-middle"></td>
            <td class="align-middle"></td>
            @if (!readOnly) {
              <!-- Looks like there is no data to fill this table. So we don't need the edit/delete
               buttons for now -->
              <!-- <td class="align-middle">
                <button nbButton ghost class="btn btn-sm btn-outline-danger border-0 fs-4" (click)="showNotPermissionDialog()">
                  <i class="fa-thin fa-pen-to-square"></i>
                </button>
              </td>
              <td class="align-middle">
                <button nbButton ghost class="btn btn-sm btn-outline-danger border-0 fs-4" (click)="showNotPermissionDialog()">
                  <i class="fa-thin fa-trash-can"></i>
                </button>
              </td> -->
            }
          </tr>
        </tbody>
      </table>
      @if (!readOnly) {
        <a class="add-declaration-button" (click)="showNotPermissionDialog()">
          (+) {{ "Add an estimated declaration" | translate }}
        </a>
      }

    </nb-accordion-item-body>
  </nb-accordion-item>

  <nb-accordion-item expanded>
    <nb-accordion-item-header>
      <span class="text">
        {{ 'Total actual leaks' | translate }}
      </span>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <table class="table skeleton">
        <thead>
          <tr>
            <th class="w-20 align-middle">{{ "Building" | translate }}</th>
            <th class="align-middle">{{ "Fluid type" | translate }}</th>
            <th class="align-middle">{{ "PRP" | translate }}</th>
            <th class="align-middle">{{ "Load/reload quantity" | translate }}</th>
            <th class="align-middle">{{ "Load/reload date" | translate }}</th>
            <th class="align-middle">{{ "Previous load/reload date" | translate }}</th>
            <th class="align-middle">{{ "Real climate impact" | translate }} ({{ 'kg eq CO2 year' | translate }})</th>
            @if (!readOnly) {
              <th class="align-middle"></th>
            }
          </tr>
        </thead>
        <tbody>
          @if ((refrigerantFluids$ | async)?.length > 0) {
            @for (refrigerant of refrigerantFluids$ | async; track refrigerant) {
            <tr>
              <td class="align-middle">{{ refrigerant.perimeter }}</td>
              <td class="align-middle">{{ refrigerant.refrigerant }}</td>
              <td class="align-middle">{{ refrigerant.gwp_20_years }}</td>
              <td class="align-middle">{{ refrigerant.reloaded_quantity }} kg</td>
              <td class="align-middle">{{ refrigerant.updated_on | date:'dd MMM y' }}</td>
              <td class="align-middle">{{ (refrigerant.last_reload | date:'dd MMM y') || '-' }}</td>
              <td class="align-middle">{{ (refrigerant.emission / 1000) | number:'1.0-1' }} <span
                  [innerHTML]="'t_co2_sub' | translate"></span></td>
              @if (!readOnly) {
                <td class="align-middle">
                  <div class="header-icons">
                    <button nbButton ghost class="btn btn-sm btn-outline-danger" (click)="editRefrigerantFluid(refrigerant)">
                      <i class="fa-thin fa-pen-to-square"></i>
                    </button>
                    <button nbButton ghost class="btn btn-sm btn-outline-danger" (click)="confirmDeleteRefrigerantFluid(refrigerant.trajectory_id, refrigerant.refrigerant, refrigerant.perimeter)">
                      <i class="fa-thin fa-trash-can"></i>
                    </button>
                  </div>
                </td>
              }
            </tr>
            }
          } @else {
            <!-- No data -->
            <tr>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              <td class="align-middle"></td>
              @if (!readOnly) {
                <td class="align-middle"></td>
              }
            </tr>
          }
        </tbody>
      </table>
      @if (!readOnly) {
        <a class="add-declaration-button" (click)="openDeclareRefrigerantFluidDialogDialog()">
          (+) {{ "Add a actual declaration" | translate }}
        </a>
      }

    </nb-accordion-item-body>
  </nb-accordion-item>

</nb-accordion>
